import { render } from "./AllBranches.vue?vue&type=template&id=952189b2&scoped=true"
import script from "./AllBranches.vue?vue&type=script&lang=js"
export * from "./AllBranches.vue?vue&type=script&lang=js"

import "./AllBranches.vue?vue&type=style&index=0&id=952189b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-952189b2"]])

export default __exports__